import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import { useUI } from "../../hooks/usePermission";
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import LoadingCircle from "../../components/Global/LoadingCircle";
import RolesTab from "./components/RolesTab";
import PermissionsTab from "./components/PermissionsTab";
import ContactingTab from "./components/ContactingTab";
import strings from "../../locales/ro.json";
import "./Admin.css";

const Admin = () => {
  const { user, loading } = UserAuth();
  const [activeTab, setActiveTab] = useState(strings.admin.tabs[0].id);

  const canAccessAdmin = useUI('navbar.admin');
  const canManageRoles = useUI('tab.admin.roles');
  const canManagePermissions = useUI('tab.admin.permissions');
  const canManageContacting = useUI('tab.admin.contacting');

  const visibleTabs = strings.admin.tabs.filter(tab => {
    if (tab.id === "roles" && !canManageRoles) return false;
    if (tab.id === "permissions" && !canManagePermissions) return false;
    if (tab.id === "contacting" && !canManageContacting) return false;
    return true;
  });

  // If the active tab is not visible, switch to the first visible one
  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.find(t => t.id === activeTab)) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <LoadingCircle />
      </div>
    );
  }

  if (!canAccessAdmin) {
    return <Navigate to="/" replace />;
  }

  const renderTab = () => {
    switch (activeTab) {
      case "roles":
        return canManageRoles ? <RolesTab /> : null;
      case "permissions":
        return canManagePermissions ? <PermissionsTab /> : null;
      case "contacting":
        return canManageContacting ? <ContactingTab /> : null;
      default:
        return null;
    }
  };

  return (
    <div>
      <HeaderElement headerText="Admin" />
      <div className="admin-container">
        <div className="admin-tabs">
          {visibleTabs.map((tab) => (
            <button
              key={tab.id}
              className={`admin-tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="admin-tab-content">
          {renderTab()}
        </div>
      </div>
    </div>
  );
};

export default Admin;
